exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AdminFeetback{display:flex;background:#fff;padding-top:20px;padding-bottom:20px}.AdminFeetback .actions{margin-bottom:20px}.AdminFeetback .actions-table{display:flex;align-items:center;flex-direction:row;color:#00adff}.AdminFeetback .actions-table .far{margin-right:10px;cursor:pointer}.AdminFeetback .btn-primary{height:32px;background-color:#fff;border:1px solid #00adff;color:#00adff;padding:0 10px;border-radius:25px;text-transform:uppercase;display:flex;align-items:center;text-align:center;cursor:pointer}.AdminFeetback .btn-primary:hover{color:#fff;background-color:#00adff}.btn-info{background:#00adff;border-color:#00adff}.btn-info:active,.btn-info:focus,.btn-info:hover{background-color:#fff;color:#00adff;border-color:#00adff}.btn-info+.btn-info{margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./yii2/frontend/frontend-assets/src/components/AdminPanel/TeacherFeetback/style.scss
// module id = 4481
// module chunks = 0